import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M6_Inheritance = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Inheritance"
    videos={[
      "https://www.youtube.com/embed/OwpL28AEfNk",
      "https://www.youtube.com/embed/nqkNhisTSgE",
      "https://www.youtube.com/embed/d5JLy3L82sM",
      "https://www.youtube.com/embed/X_l4-LOW7G4",
      "https://www.youtube.com/embed/uK7kf85hEds",
      "https://www.youtube.com/embed/ZqNOfdA9AGc",
      "https://www.youtube.com/embed/MmR_qpYthP8",
    ]}
    takeaways={[
      { text: "Learn about all the inheritance theory parts with example codes and respective flow charts." },
      { text: "Learn about the diamond problem." },
      { text: "Learn the coding part very clearly (only application-based coding questions will be given)." },
      { text: "The coding part in inheritance is easy compared to others. You just need to know basic syntaxes." },
      { text: "Learn the syntaxes properly and read the question carefully (in the question, they don't mention directly what type of inheritance is needed; we need to figure that out)." },
      { text: "Have an idea on what ambiguity is and how it arises." },
      { text: "In the exams, write the expected output after code at last (even though your code logic is wrong, write the expected output as per the question). (If you do this, your chance of getting more marks will be increased)." },
    ]}
    questions={[
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M6_Inheritance;
